<div class="card">
	<div class="card-header">
		<h1>Nomenclatura
			<i tooltip="Contraer todas las cuentas" class="fa fa-angles-up clickeable"
				(click)="showOrCollapseAll(nomenclature, false)"></i>
			<a href="/configuration/expense-category" tooltip="Ir a editar categoria"><i class="fa fa-circle-right"></i>
			</a>
		</h1>
	</div>
	<div class="card-body">
		<div>
			<table class="table table-bordered">
				<thead>
					<tr class=" title">
						<th>Nomenclatura</th>
						<th>Cuenta</th>
						<th>Naturaleza del Saldo</th>
						<th class="no-border-td"></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let nom of nomenclature">
						<tr class=" general-account">
							<td>
								{{nom.displayId}}
								<ng-container *ngIf="nom.children.length > 0">
									<i [ngClass]="nom.show ? 'fa-angle-up':'fa-angle-down'" class="fa clickeable"
										(click)="nom.show = !nom.show;"></i>
								</ng-container>
							</td>
							<td>
								{{nom.name}}
							</td>
							<td>
								{{nom.balance > 0 ? 'Acreedor': 'Deudor'}}
							</td>
							<td class="no-border-td">

							</td>
						</tr>
						<ng-container *ngIf="nom.children.length > 0 && nom.show">
							<ng-container *ngFor="let ch1 of nom.children">
								<tr class=" second-account">
									<td>
										<div class="in-rect">
											<div class="rect">
											</div>
										</div>
										{{ch1.displayId}}
										<ng-container *ngIf="ch1.children.length > 0">
											<i [ngClass]="ch1.show ? 'fa-angle-up':'fa-angle-down'"
												class="fa clickeable" (click)="ch1.show = !ch1.show;"></i>
										</ng-container>
									</td>
									<td>
										{{ch1.name}}
									</td>
									<td>
										{{ch1.balance > 0 ? 'Acreedor': 'Deudor'}}
									</td>
									<td class="no-border-td">

									</td>
								</tr>
								<ng-container *ngIf="ch1.children.length > 0 && ch1.show">
									<ng-container *ngFor="let ch2 of ch1.children">
										<tr class=" third-account">
											<td>
												<div class="in-rect">
													<div class="rect" style="width: 30px !important;">
													</div>
												</div>
												{{ch2.displayId}}
												<ng-container *ngIf="ch2.children.length > 0">
													<i [ngClass]="ch2.show ? 'fa-angle-up':'fa-angle-down'"
														class="fa clickeable" (click)="ch2.show = !ch2.show;"></i>
												</ng-container>
											</td>
											<td>
												{{ch2.name}}
											</td>
											<td>
												{{ch2.balance > 0 ? 'Acreedor': 'Deudor'}}
											</td>
											<td class="no-border-td option-tab text-center">
												<i class="fa fa-circle-plus text-success clickeable"
													(click)="addCategory(ch2)"></i>
											</td>
										</tr>
										<ng-container *ngIf="ch2.children.length > 0 && ch2.show">
											<ng-container *ngFor="let ch3 of ch2.children; let i = index">
												<tr class=" fourth-account" [class.hide-all]="toDelete?.id==ch3.id">
													<ng-container *ngIf="!ch3.temporal">
														<td>
															<div class="in-rect">
																<div class="rect" style="width: 60px !important;">
																</div>
															</div>
															{{ch3.displayId}}
														</td>
														<td>
															{{ch3.name}}
														</td>
														<td>
															{{ch3.balance > 0 ? 'Acreedor': 'Deudor'}}
														</td>
														<td class="no-border-td option-tab">
															<div class="icon-group">
																<i class="fa fa-edit text-info clickeable"
																	(click)="ch3.temporal = true;"></i>
																<div class="container-superposition" title="Borrar">
																	<div class="element-superposition"
																		*ngIf="toDelete?.id == ch3.id">
																		<span class="text-info">¿Está seguro que desea
																			eliminar esta cuenta?</span>
																		<div class="a-container">
																			<div class="clickeable"
																				(click)="toDelete.deleting = false; toDelete = null;">
																				<i class="fa fa-ban"></i>NO
																			</div>
																			<div class="clickeable text-danger"><i
																					class="fa fa-trash"
																					(click)="deleteAccount()"></i>SÍ
																			</div>
																		</div>
																	</div>
																	<span class="clickeable text-danger">
																		<i *ngIf="!ch3.deleting" class="fa fa-trash"
																			(click)="toDelete = ch3"></i>
																		<span *ngIf="ch3.deleting"
																			class="spinner-border spinner-border-sm"
																			aria-hidden="true"></span>
																	</span>
																</div>
															</div>
														</td>
													</ng-container>
													<ng-container *ngIf="ch3.temporal">
														<td>
															<div class="input-group">
																<input type="text" class="form-control"
																	[(ngModel)]="ch3.displayId"
																	placeholder="Ingresa el identificador">
															</div>
														</td>
														<td>
															<div class="input-group">
																<input type="text" class="form-control"
																	[(ngModel)]="ch3.name"
																	placeholder="Ingresa el nombre">
															</div>
														</td>
														<td>
															<div class="input-group">
																<select name="type" id="type" class="form-select"
																	[(ngModel)]="ch3.balance">
																	<option [ngValue]="-1">Acreedor</option>
																	<option [ngValue]="1">Deudor</option>
																</select>
															</div>
														</td>
														<td class="no-border-td option-tab" style="vertical-align: middle;">
															<div class="icon-group">
																<i *ngIf="!ch3.creating"
																	class="fa fa-save text-success clickeable"
																	(click)="create(ch3, ch2)"></i>
																<span *ngIf="ch3.creating || ch3.editing"
																	class="spinner-border spinner-border-sm"
																	aria-hidden="true"></span>
																<i class="fa fa-ban text-danger clickeable"
																	(click)="delay(ch2.children, i)"></i>
															</div>
														</td>
													</ng-container>
												</tr>
											</ng-container>
										</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="toDelete">
	<div class="for-click" (click)="toDelete.deleting = false; toDelete = null;"></div>
</div>